(ns common.schema.entities.ic-decision.schema
  (:require
   [common.schema.schema-utils :as su]
   [common.schema.entities.decision :as decision]
   [common.schema.entities.common.options :as common-options]
   [common.schema.entities.decision-options :as decision-options]))





(def schema
  (concat
   decision/schema

   (su/keyword-field :decision/fund-has-sufficient-capacity
                     "Fund has sufficient capacity to complete the deal"
                     common-options/condition-true-false-options
                     {:authorization su/access-user-user
                      :default-field-visibility :in-use})

   (su/text-multiline-field :decision/fund-has-sufficient-capacity-notes
                            "Notes"
                            {:authorization su/access-user-user
                             :default-field-visibility :in-use})

   (su/keyword-field :decision/complies-with-investment-strategy
                     "Proposed investment complies with investment strategy, criteria and restrictions"
                     common-options/condition-true-false-options
                     {:authorization su/access-user-user
                      :default-field-visibility :in-use})

   (su/text-multiline-field :decision/complies-with-investment-strategy-notes
                            "Proposed investment complies with investment strategy, criteria and restrictions - Notes"
                            {:authorization su/access-user-user
                             :default-field-visibility :in-use})

   (su/keyword-field :decision/ic-approves-proposed-investment
                     "Investment committee approves proposed investment and sends it to the AIFM"
                     decision-options/ic-approval-options
                     {:authorization su/access-user-user
                      :default-field-visibility :in-use})

   (su/text-multiline-field :decision/ic-approves-proposed-investment-notes
                            "Notes"
                            {:authorization su/access-user-user
                             :default-field-visibility :in-use})

   (su/multi-ref-field :decision/investment-reservations
                       "Investment reservations"
                       [:entity.type/investment-reservation]
                       {:authorization su/access-user-user
                        :default-field-visibility :in-use})

   (su/calculated-field :decision/total-investment-decision
                        "Total investment decision"

                        ; Todo
                        {:data-type   :data.type/currency-value
                         :calc-fn     (fn [{:keys [logger entity-data entity-lookup
                                                   reverse-lookup tr bigdec->float float->bigdec
                                                   get-field-schema display-string]}]
                                        0)})

   (su/multi-ref-field :decision/conditions
                       "Conditions"
                       [:entity.type/decision-condition]
                       {:authorization su/access-user-user
                        :default-field-visibility :in-use})

   (su/text-multiline-field :decision/notes
                            "Notes"
                            {:authorization su/access-user-user
                             :default-field-visibility :in-use})))

(def required-fields
  #{:decision/date
    :decision/fund-has-sufficient-capacity
    :decision/complies-with-investment-strategy
    :decision/ic-approves-proposed-investment})
